<template>
<v-container mt-4>
     <!-- <div class="mt-4"> -->
       <NewRegistration></NewRegistration>
     <!-- </div> -->
</v-container>

</div>
</template>

<script>
import $ from 'jquery';
import { mapState } from 'vuex';
import { api } from '../api.js';
import {axios, post} from 'axios';
import NewRegistration from './NewRegistration'

export default {
  userName: '',
  components: {
    NewRegistration
  },
  beforeRouteLeave: (to,from,next)=>{
    localStorage.setItem("profilePhoto", null)
    next()
  },
  data() {
    return {
      snackbar: false,
      snackbarColor: '',
      mode: '',
      timeout: 6000,
      snackbarText: 'Hello, I\'m a snackbar',
      output: '',
      email: 'nfn',
      password: '123456',
      clinic_id: ''

    }
  },
  methods: {
    login() {


    },
  }
}
</script>
<style scoped>
.container {
  height: 100vh;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/profileAdd.vue